import { MobiDocument } from './MobiDocument';

export class PaletteEnfantANDocument extends MobiDocument{
    private _id : string;
    private _rev : string;
    private id : number;
    private etablissement_id : number;
    private ramassage : boolean;
    private repas : boolean;
    private supplement : boolean

    constructor(paletteenfant : any){
        super()
        this._id = paletteenfant._id;
        this._rev = paletteenfant._rev;
        this.id = paletteenfant.id;
        this.etablissement_id = paletteenfant.etablissement_id;
        this.ramassage = paletteenfant.ramassage;
        this.repas = paletteenfant.repas;
        this.supplement = paletteenfant.supplement;
    }

    public get_id(): string {
        return this._id;
    }

    public set_id(_id: string): void {
        this._id = _id;
    }

    public get_rev(): string {
        return this._rev;
    }

    public set_rev(_rev: string): void {
        this._rev = _rev;
    }

    public getId(): number {
        return this.id;
    }

    public setId(id: number): void {
        this.id = id;
    }

    public getEtablissement_id(): number {
        return this.etablissement_id;
    }

    public setEtablissement_id(etablissement_id: number): void {
        this.etablissement_id = etablissement_id;
    }

    public isRamassage(): boolean {
        return this.ramassage;
    }

    public setRamassage(ramassage: boolean): void {
        this.ramassage = ramassage;
    }

    public isRepas(): boolean {
        return this.repas;
    }

    public setRepas(repas: boolean): void {
        this.repas = repas;
    }

    public isSupplement(): boolean {
        return this.supplement;
    }

    public setSupplement(supplement: boolean): void {
        this.supplement = supplement;
    }
}